export const DEFAULT_ACCENT = '#3B5BDB';

export const THEME_PRESETS = {
  default: {
    name: 'Default',
    accent:      '#3B5BDB',
    sidebar:     '#1E2A3B',
    sidebarEnd:  '#151F2E',
    bg:          '#F0F2F5',
    surface:     '#FFFFFF',
    topbarBg:    'rgba(255,255,255,0.95)',
    topbarBorder:'#DDE1E7',
    text:        '#1A202C',
    text2:       '#2D3748',
    muted:       '#718096',
    border:      '#DDE1E7',
    border2:     '#C8CDD6',
    accentBg:    null, // computed
  },
  certis: {
    name: 'Certis',
    accent:      '#F39A2E',   // Certis orange
    sidebar:     '#0D2A5A',   // Certis navy
    sidebarEnd:  '#071A38',   // deeper navy at bottom
    bg:          '#F4F6FA',   // light page bg
    surface:     '#FFFFFF',   // white cards
    topbarBg:    '#FFFFFF',
    topbarBorder:'#E5E7EB',
    text:        '#1A202C',
    text2:       '#2D3748',
    muted:       '#6B7280',
    border:      '#E5E7EB',
    border2:     '#CBD5E0',
    accentBg:    '#FEF3E2',   // soft orange tint
  },
};

// Compute and apply accent-derived CSS variables
export function applyAccentColor(hex, accentBgOverride) {
  if (!hex || !/^#[0-9A-Fa-f]{6}$/.test(hex)) hex = DEFAULT_ACCENT;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const dk = (v, f) => Math.max(0, Math.round(v * (1 - f)));
  const lt = (v, f) => Math.min(255, Math.round(v + (255 - v) * f));
  const hex3 = (r, g, b) => '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('');
  const root = document.documentElement;
  root.style.setProperty('--accent',       hex);
  root.style.setProperty('--accent-dark',  hex3(dk(r,.22), dk(g,.22), dk(b,.22)));
  root.style.setProperty('--accent-light', hex3(lt(r,.55), lt(g,.55), lt(b,.55)));
  root.style.setProperty('--accent-bg',    accentBgOverride || hex3(lt(r,.92), lt(g,.92), lt(b,.92)));
}

// Apply a full brand theme preset
export function applyFullTheme(presetKeyOrObj) {
  const p = typeof presetKeyOrObj === 'string'
    ? THEME_PRESETS[presetKeyOrObj]
    : presetKeyOrObj;
  if (!p) return;
  applyAccentColor(p.accent, p.accentBg);
  const root = document.documentElement;
  root.style.setProperty('--sidebar',       p.sidebar);
  root.style.setProperty('--sidebar-end',   p.sidebarEnd);
  root.style.setProperty('--bg',            p.bg);
  root.style.setProperty('--surface',       p.surface);
  root.style.setProperty('--topbar-bg',     p.topbarBg);
  root.style.setProperty('--topbar-border', p.topbarBorder);
  root.style.setProperty('--text',          p.text);
  root.style.setProperty('--text2',         p.text2);
  root.style.setProperty('--muted',         p.muted);
  root.style.setProperty('--border',        p.border);
  root.style.setProperty('--border2',       p.border2);
  document.body.style.background = p.bg;
}

export const T = {
  sidebar:  'var(--sidebar)',
  active:   'var(--accent)',
  bg:       'var(--bg)',
  surface:  'var(--surface)',
  border:   'var(--border)',
  border2:  'var(--border2)',
  color:    'var(--text)',
  txt2:     'var(--accent)',
  muted:    'var(--muted)',
  g50:      'var(--accent-bg)',
  g100:     'var(--accent-bg)',
  g200:     'var(--accent-light)',
  g700:     'var(--accent-dark)',
  txt:      '#FFFFFF',
};
